import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, Subscription, switchMap } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
    private currentVersion = window.__env?.appVersion ?? 'unknown';

    private sub?: Subscription;

    constructor(
        private http: HttpClient,
        private modal: NzModalService
    ) {}

    startPolling(intervalMs = 60_000): void {
        interval(intervalMs)
        .pipe(
            switchMap(() =>
            this.http.get<{ version: string }>('/assets/version.json', {
                params: { t: Date.now().toString() }, // cache bust
            })
            )
        )
        .subscribe(({ version }) => {
            if (version && version !== this.currentVersion) {
                this.promptReload();
            }
        });
    }

    stopPolling(): void {
        this.sub?.unsubscribe();
    }

    private promptReload(): void {
        this.modal.confirm({
            nzTitle: 'New version available',
            nzContent: 'A new version of this app has been deployed. Click OK to reload and use the latest version.',
            nzOkText: 'Reload now',
            nzCancelText: 'Later',
            nzOnOk: () => {
                window.location.reload();
            }
        });
    }
}
